import makeRequest from '@justgiving/http-client';
import config from '../../config';

const logInfo = (data: object) => async () => {
  try {
    makeRequest(`${config.loggingApiURL}/info`, {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({
        ...data,
        app: {
          name: config.appName,
        },
      }),
    });
  } catch (e) {
    // do nothing
  }
};

export default logInfo;
